import { createAction } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import { reducer as contractLinkCreate } from '@app/features/contractLink/contractLinkCreate';
import { reducer as exportValues } from '@app/features/exportInputValues';
import { reducer as externalDocument } from '@app/features/externalDocument';
import { reducer as form } from '@app/features/form';
import { reducer as formRecommendation } from '@app/features/formRecommendation';
import { reducer as embeddedDocument } from '@app/features/integration/embeddedDocument';
import { reducer as embeddedDraftPreview } from '@app/features/integration/embeddedDraftPreview';
import { reducer as payment } from '@app/features/payment';
import { reducer as subscription } from '@app/features/subscription/state';
import pdf from '@app/libs/reactPdfJs/store/pdfReducer';

import { reducer as customBrandSetting } from '../features/customBrandSetting';
import account from './account/reducers';
import bulkRequest from './bulkRequest/reducers';
import contractAuthentication from './contract-authentication/reducers';
import contractProgress from './contract-progress/reducers';
import contractSetup from './contract-setup/reducers';
import document from './document/reducers';
import documentProgress from './documentProgress/reducers';
import documents from './documents/reducers';
import documentSetup from './documentSetup/reducers';
import documentsExport from './documentsExport/reducers';
import editingDocument from './editingDocument/reducers';
import editingDocuments from './editingDocuments/reducers';
import { reducer as onboardingBanner } from './guide/state';
import { routerReducer as router } from './history';
import modal from './modal/reducers';
import participant from './participant/reducers';
import requesterLink from './requesterLink/reducers';
import signingProgressInformation from './signingProgressInformation/reducers';
import softLanding from './softLanding/reducers';
import template from './template/reducers';
import templates from './templates/reducers';
import ui from './ui/reducers';
import user from './user/reducers';

const reducer = combineReducers({
  account,
  bulkRequest,
  contractAuthentication,
  contractLinkCreate,
  exportValues,
  contractProgress,
  contractSetup,
  customBrandSetting,
  document,
  documentProgress,
  documents,
  documentsExport,
  documentSetup,
  editingDocument,
  editingDocuments,
  embeddedDocument,
  embeddedDraftPreview,
  externalDocument,
  form,
  formRecommendation,
  modal,
  onboardingBanner,
  participant,
  payment,
  pdf,
  requesterLink,
  router,
  signingProgressInformation,
  softLanding,
  subscription,
  template,
  templates,
  ui,
  user,
});

const rootReducer: typeof reducer = (state, action) => {
  if (action.type === resetStore.type) {
    return reducer(undefined, action);
  }
  return reducer(state, action);
};

export const resetStore = createAction('RESET_STORE');
export default rootReducer;
